import { FileSearchOutlined } from '@ant-design/icons';
import { billListSelectors } from 'containers/App/selectors';
import { useCallback, useEffect, useState, FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { exportFile } from 'utils/export.api';
import { HeaderListBill, Pagination, SearchListBilling } from 'components';
import TableListBill from './TableListBill';
import { resetSearchValueListBilling, setCurrentPageListBilling, setSearchValueListBilling } from './slice';
import { Wrap } from './styles';
import { getDataExportBill, getListBills, updateFile, updateItemInvoice } from './thunk';

type Props = {
  title: string;
  icon: any;
};

type SearchBill = {
  facility_name: string;
  facility_code: string;
  year: string;
  month: string;
};

const initialvalueSearch = {
  facility_code: '',
  facility_name: '',
  year: '',
  month: '',
};

const ListBilling: FC<Props> = () => {
  const dispatch = useDispatch();
  const { invoices, currentPage, searchValue } = useSelector(billListSelectors);

  const [valueSearch, setValueSearch] = useState<SearchBill>(searchValue);
  const [page, setPage] = useState<number>(currentPage);

  const history = useHistory();

  useEffect(() => {
    dispatch(getListBills({ search: valueSearch, page: page }));
    return () => {
      if (history.location.pathname !== '/billings/detail') {
        dispatch(resetSearchValueListBilling());
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, history.location.pathname]);

  const searchBill = useCallback(
    async (value: SearchBill) => {
      await dispatch(getListBills({ search: value, page: 1 }));
      setValueSearch(value);
      dispatch(setSearchValueListBilling(value));
      dispatch(setCurrentPageListBilling(1));
      setPage(1);
    },
    [dispatch],
  );

  const resetValueSearch = useCallback(async () => {
    await dispatch(getListBills({ search: initialvalueSearch, page: 1 }));
    dispatch(resetSearchValueListBilling());
    setValueSearch(initialvalueSearch);
    setPage(1);
  }, [dispatch]);

  const changePage = useCallback(
    (page: number) => {
      setPage(page);
      dispatch(setCurrentPageListBilling(page));
      dispatch(getListBills({ search: valueSearch, page: page }));
    },
    [dispatch, valueSearch],
  );

  const exportBill = async (param: {
    i_id: string;
    facility_name: string;
    invoice_month: string;
    facility_id: string;
    invoice_id: string;
    facility_code: string;
  }) => {
    const dataBill: any = await dispatch(
      getDataExportBill({
        i_id: param.i_id,
        facility_id: param.facility_id,
        invoice_month: param.invoice_month,
        invoice_id: param.invoice_id,
      }),
    );
    const file = await exportFile(
      dataBill.payload.responseBill,
      'xlsx',
      'BillHexabase',
      `${param.facility_code || ''}_請求書_${param.facility_name}_${param.invoice_month}`,
    );
    if (file !== 'error') {
      const resultAction: any = await dispatch(
        updateFile({
          i_id: param.i_id,
          file,
          filename: `${param.facility_code || ''}_請求書_${param.facility_name}_${param.invoice_month}.xlsx`,
        }),
      );
      if (updateFile.fulfilled.match(resultAction)) {
        await dispatch(
          updateItemInvoice({
            i_id: param.i_id,
            data: {
              changes: [{ id: 'file_invoice', value: [resultAction.payload.file_id] }],
              use_display_id: true,
              is_force_update: true,
            },
          }),
        );
      }
    }

    if (dataBill.payload.hospitalBills) {
      setTimeout(() => {
        exportFile(
          dataBill.payload.hospitalBills,
          'xlsx',
          'DetailCPAP',
          `${param.facility_code || ''}_ご使用明細書_${param.facility_name}_${param.invoice_month}`,
        );
      }, 1000);
    }

    if (dataBill.payload.psgBills) {
      setTimeout(() => {
        exportFile(
          dataBill.payload.psgBills,
          'xlsx',
          'DetailPSG',
          `${param.facility_code || ''}_PSG検査明細_${param.facility_name}_${param.invoice_month}`,
        );
      }, 2000);
    }

    if (dataBill.payload.inspectionBills) {
      setTimeout(() => {
        exportFile(
          dataBill.payload.inspectionBills,
          'xlsx',
          'DetailInspection',
          `${param.facility_code || ''}_簡易検査明細_${param.facility_name}_${param.invoice_month}`,
        );
      }, 3000);
    }
  };

  return (
    <Wrap>
      <HeaderListBill title="請求書一覧" icon={FileSearchOutlined} />
      <SearchListBilling valueSearch={valueSearch} onSearch={searchBill} resetSearch={resetValueSearch} />
      <div className="section">
        <Pagination page={page} per_page={20} totalItems={invoices.totalItems} onChangePage={changePage} />
        <div className="table">
          <TableListBill dataSource={invoices.items} exportBill={exportBill} />
        </div>
      </div>
    </Wrap>
  );
};

export default ListBilling;
